import { getValidationResolver, useForm } from '@common-fe/common-fe';
import * as yup from 'yup';

import { VALIDATORS } from '@/common';
import { REQUIRED_TEXT } from '@/common/constants';
import { EmployerIdType } from '@/modules/ExpressSetup/ExpressSetupSignUp/expressSetupSignUp.constants';

export enum CreateOrganizationField {
  legalName = 'legalName',
  displayName = 'displayName',
  employerIdType = 'employerIdType',
  employerId = 'employerId',
  taxId = 'taxId',
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
}

export interface CreateOrganizationForm {
  [CreateOrganizationField.legalName]: string;
  [CreateOrganizationField.displayName]: string;
  [CreateOrganizationField.employerIdType]: EmployerIdType;
  [CreateOrganizationField.employerId]: string;
  [CreateOrganizationField.taxId]: string;
  [CreateOrganizationField.addressLine1]: string;
  [CreateOrganizationField.addressLine2]: string;
  [CreateOrganizationField.city]: string;
  [CreateOrganizationField.state]: string;
  [CreateOrganizationField.zipCode]: string;
}

const useCreateOrganizationForm = () => {
  const methods = useForm<CreateOrganizationForm>({
    resolver: getValidationResolver({
      [CreateOrganizationField.legalName]: VALIDATORS.TEXT_LENGTH.required(REQUIRED_TEXT),
      [CreateOrganizationField.displayName]: VALIDATORS.TEXT_LENGTH.required(REQUIRED_TEXT),
      [CreateOrganizationField.employerIdType]: yup.mixed<EmployerIdType>().required(REQUIRED_TEXT),
      [CreateOrganizationField.employerId]: yup.string().when(CreateOrganizationField.employerIdType, {
        is: (val?: EmployerIdType) => val === EmployerIdType.CUSTOM,
        then: (schema) => schema.required(REQUIRED_TEXT),
        otherwise: (schema) => schema,
      }),
      [CreateOrganizationField.taxId]: VALIDATORS.TAX_ID,
      [CreateOrganizationField.addressLine1]: VALIDATORS.TEXT_LENGTH.required(REQUIRED_TEXT),
      [CreateOrganizationField.city]: VALIDATORS.CITY,
      [CreateOrganizationField.state]: VALIDATORS.REQUIRED_STRING,
      [CreateOrganizationField.zipCode]: VALIDATORS.ZIP_CODE,
    }),
  });

  return { methods };
};

export default useCreateOrganizationForm;
